import App from './containers/App';
import StaticComponentRenderer from './containers/StaticComponentRenderer';
import {
  Home,
  Landing,
  LoggedInPage,
  SeasonTicket,
  Search,
  LoginWall,
  ConsentsWall,
  Register,
  Revoke,
  SearchResults
} from './pages/Pages';
// SSR 404 context helper
import NotFound from './components/Common/NotFound';

export default () => [
  {
    component: StaticComponentRenderer,
    path: '/jp/components/:component',
    exact: true
  },
  {
    component: Revoke,
    path: '/auth/consents/revoke',
    exact: true,
    strict: false
  },
  {
    component: App,
    routes: [
      {
        component: Home,
        path: '/',
        exact: true
      },
      {
        component: ConsentsWall,
        path: '/dashboard/profile/data-preferences/',
        exact: true,
        strict: false
      },
      {
        component: Landing,
        path: '/:country/parking/:slug/',
        exact: true,
        strict: true
      },
      {
        component: Search,
        path: '/searchnew',
        exact: true,
        strict: true
      },
      {
        component: LoginWall,
        path: '/auth/login',
        exact: true,
        strict: false
      },
      {
        component: ConsentsWall,
        path: '/consent-wall',
        exact: true,
        strict: false
      },
      {
        component: Register,
        path: '/registration',
        exact: true,
        strict: false
      },
      {
        component: SearchResults,
        path: '/search/',
        exact: true
      },
      {
        component: SearchResults,
        path: '/searchresultsnew/',
        exact: true
      },
      {
        // TODO : Remove me when we've got authenticated routes to worry about
        component: LoggedInPage,
        path: '/loggedInOnly',
        exact: true
      },
      {
        component: SeasonTicket,
        path: '/season-tickets/cornwall',
        exact: true
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
];
